module.exports = __webpack_public_path__ + "static/img/jinr.f7003de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jinr.png
// module id = 7RfC
// module chunks = 0